import MasterProductCURModule from "@/modules/MasterProductCUR";

function EditMasterProductPage() {
  return <MasterProductCURModule type="edit" />;
}

export default EditMasterProductPage;
